import StyledInputField from "../../../../components/parts/styled-field/styled-input-field"
import { Field, reduxForm, InjectedFormProps } from "redux-form"
import { formData, FormId, IFormField } from "./form-meta"
import { validate } from "./validation"
import React from "react"
import { AuthSendButton } from "../../../../components/templates/auth/components/auth-send-button"

export class FormComponent extends React.Component<
  InjectedFormProps<{}, IFormField>
> {
  public render() {
    const { handleSubmit, submitting } = this.props
    return (
      <form onSubmit={handleSubmit}>
        {formData.map((data, i) => (
          <Field key={i} component={StyledInputField} {...data} />
        ))}
        <AuthSendButton
          isSending={submitting}
          text={"送信"}
          sendingText={"送信中です"}
          onClick={handleSubmit}
        />
      </form>
    )
  }
}

export const Form = reduxForm({
  form: FormId,
  validate,
})(FormComponent)
